module.exports = __webpack_public_path__ + "img/album06_02.f7a652ec.jpg";